import axios from "axios";
import { api } from "./api_route";

export const createRespondentCounselAPI = async (respondentCounselData) => {
  try {
    const config = {};
    if (
      typeof FormData !== "undefined" &&
      respondentCounselData instanceof FormData
    ) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.post(
      `${api}/respondentCounsel/create`,
      respondentCounselData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const getRespondentCounselByCaseIDAPI = async (caseID) => {
  try {
    const response = await axios.get(`${api}/respondentCounsel/case/${caseID}`);
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const updateRespondentCounselAPI = async (
  respondentCounselID,
  respondentCounselData,
) => {
  try {
    const config = {};
    if (
      typeof FormData !== "undefined" &&
      respondentCounselData instanceof FormData
    ) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.put(
      `${api}/respondentCounsel/update/${respondentCounselID}`,
      respondentCounselData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const deleteRespondentCounselAPI = async (respondentCounselID) => {
  try {
    const response = await axios.delete(
      `${api}/respondentCounsel/delete/${respondentCounselID}`,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const deleteRespondentCounselDocumentAPI = async (documentID) => {
  try {
    const response = await axios.delete(
      `${api}/respondentCounsel/document/delete/${documentID}`,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const respondentCounselDocumentDownload = async (values) => {
  try {
    const response = await axios.get(
      `${api}/documents/respondentCounselDocuments/${values.original.documentNewName}`,
      {
        responseType: "blob",
      },
    );

    return response.data;
  } catch (error) {
    return [];
  }
};
// Document Categories Constants
export const RESPONDENTCOUNSEL_DOCUMENT_CATEGORIES = {
  BARCOUNCILCERTIFICATE: 1243,
  VAKALTH: 1242,
};

export const DOCUMENT_CATEGORY_LABELS = {
  1243: "Bar Council Certificate",
  1242: "Vakalatnama",
};
